import React, { useEffect, useState } from 'react';
import { Loader2, Settings2 } from 'lucide-react';
import { toast } from 'sonner';
import { Button } from '@/components/ui/button';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { bapi } from '@/lib/billingApi';

const FIELDS = [
  ['reminder_days', 'Renewal reminder emails (days before)', '30, 7'],
  ['retry_days', 'Retry a failed renewal after (days)', '1, 3, 5'],
  ['grace_days', 'Grace period after a failed renewal (days)', '7'],
  ['lead_days_annual', 'Charge annual plans early by (days)', '5'],
  ['lead_days_monthly', 'Charge monthly plans early by (days)', '1'],
  ['admin_alert_email', 'Billing alert email', 'you@company.com'],
];

const toForm = (s) => Object.fromEntries(FIELDS.map(([k]) => [k, Array.isArray(s[k]) ? s[k].join(', ') : String(s[k] ?? '')]));

export const BillingSettingsForm = () => {
  const [f, setF] = useState(null);
  const [busy, setBusy] = useState(false);
  useEffect(() => { bapi('/admin/billing/settings').then((s) => setF(toForm(s))).catch((e) => toast.error(e.message)); }, []);

  const save = async () => {
    setBusy(true);
    try {
      setF(toForm(await bapi('/admin/billing/settings', { method: 'PUT', body: f })));
      toast.success('Billing settings saved');
    } catch (e) { toast.error(e.message); } finally { setBusy(false); }
  };

  return (
    <Card className="border-slate-200" data-testid="billing-settings-card">
      <CardHeader className="pb-3"><CardTitle className="text-lg flex items-center gap-2"><Settings2 className="w-5 h-5 text-[#00247D]" />Renewal settings</CardTitle></CardHeader>
      <CardContent>
        {!f ? <Loader2 className="w-5 h-5 animate-spin text-[#00247D]" /> : (
          <div className="space-y-4">
            <div className="grid sm:grid-cols-2 gap-4">
              {FIELDS.map(([k, label, ph]) => (
                <div key={k}>
                  <Label className="text-xs" htmlFor={`bs-${k}`}>{label}</Label>
                  <Input id={`bs-${k}`} value={f[k]} placeholder={ph} onChange={(e) => setF((x) => ({ ...x, [k]: e.target.value }))} data-testid={`billing-setting-${k}`} />
                </div>
              ))}
            </div>
            <Button onClick={save} disabled={busy} className="bg-[#00247D] hover:bg-[#001A5C]" data-testid="billing-settings-save-btn">
              {busy && <Loader2 className="w-4 h-4 mr-1.5 animate-spin" />}Save settings
            </Button>
          </div>
        )}
      </CardContent>
    </Card>
  );
};
